// extracted by mini-css-extract-plugin
var _1 = "FolderListItem-moduleavatar__o7_uM ListItemAvatar-moduleavatar__RkZvj";
export { _1 as "avatar" }
